import { styled } from '@mui/material';

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
}));

export const PickerInput = styled('input')<{ isDisabled?: boolean }>`
  width: 40px;
  height: 40px;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  border: 1px solid ${(props) => props.theme.palette.primary.dark};
  border-radius: 8px;
  background-color: ${(props) => props.value};
  appearance: none;
  padding: 0;
  outline: none;
  &::-webkit-color-swatch {
    border: none;
  }
  &:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.5);
  }
`;

export const PickerWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
`;
